module.exports = ".cepInvalido{\r\n    color: red;\r\n}"